import { ErrorCategory } from './errorClassifier'

export interface ErrorMessageEntry {
  recruiterHeadline: string
  recruiterBody: string
  recruiterGuidance?: string[]
  candidateHeadline: string
  candidateBody: string
  candidateGuidance?: string[]
}

export const ERROR_MESSAGES: Record<ErrorCategory, ErrorMessageEntry> = {
  resume_unreadable: {
    recruiterHeadline: 'Resume Could Not Be Read',
    recruiterBody: 'The candidate\'s resume appears to be image-only or contains no extractable text. ',
    candidateHeadline: 'We Could Not Read This Resume',
    candidateBody: 'Resume appears to be an image or scanned document. We need a text-based PDF to extract and analyze your information.',
  },

  resume_format: {
    recruiterHeadline: 'Resume Layout Is Too Complex',
    recruiterBody: 'Resume layout is too complex for our parser — multi-column, heavy tables, or unusual formatting. ',
    candidateHeadline: 'This Resume Format Is Not Supported',
    candidateBody: 'Resume layout is too complex for us to parse. Please simplify it to a single-column format.',
  },

  resume_language: {
    recruiterHeadline: 'Resume Language Not Supported',
    recruiterBody: 'The resume appears to be in a language other than English.',
    candidateHeadline: 'Your Resume Should Be in English',
    candidateBody: 'Your resume must be written in English for us to analyze it.',
  },

  ai_unavailable: {
    recruiterHeadline: 'AI Processing Temporarily Unavailable',
    recruiterBody: 'Our AI service is temporarily unavailable or encountered an error. Please try again in a few moments.',
    candidateHeadline: 'Analysis Temporarily Unavailable',
    candidateBody: 'Our AI service is temporarily unavailable. Please try again in a few moments.',
  },

  match_failed: {
    recruiterHeadline: 'Profile Matching Could Not Complete',
    recruiterBody: 'We were unable to complete the profile matching process. Please try again.',
    candidateHeadline: 'Profile Matching Could Not Complete',
    candidateBody: 'We were unable to complete the matching process. Please try again.',
  },

  network_failure: {
    recruiterHeadline: 'Connection Problem',
    recruiterBody: 'A network connection error occurred. Please check your internet connection and try again.',
    candidateHeadline: 'Connection Problem',
    candidateBody: 'A network connection error occurred. Please check your internet connection and try again.',
  },

  access_denied: {
    recruiterHeadline: 'You Do Not Have Permission for This Action',
    recruiterBody: 'You do not have the necessary permissions to perform this action. Please contact your administrator.',
    candidateHeadline: 'Access Denied',
    candidateBody: 'You do not have permission to access this resource.',
  },

  session_expired: {
    recruiterHeadline: 'Your Session Has Expired',
    recruiterBody: 'Your session has expired. Please sign in again to continue.',
    candidateHeadline: 'Your Session Has Expired',
    candidateBody: 'Your session has expired. Please sign in again to continue.',
  },

  rate_limited: {
    recruiterHeadline: 'Daily Processing Limit Reached',
    recruiterBody: 'You have reached your daily processing limit. Please try again tomorrow or contact support.',
    candidateHeadline: 'Too Many Attempts',
    candidateBody: 'You have made too many attempts. Please try again later.',
  },

  invalid_zip: {
    recruiterHeadline: 'Invalid ZIP File',
    recruiterBody: 'The uploaded ZIP file is corrupted or empty. Please ensure the file is a valid ZIP archive containing PDF resumes.',
    candidateHeadline: 'Invalid ZIP File',
    candidateBody: 'The uploaded ZIP file is corrupted or empty. Please ensure the file is a valid ZIP archive.',
  },

  s3_upload_failed: {
    recruiterHeadline: 'Upload Storage Temporarily Unavailable',
    recruiterBody: 'Our upload service is temporarily unavailable. This is usually a temporary issue. Please try again in a few moments.',
    candidateHeadline: 'Upload Service Temporarily Unavailable',
    candidateBody: 'Our upload service is temporarily unavailable. Please try again in a few moments.',
  },

  processing_timeout: {
    recruiterHeadline: 'Processing Took Too Long',
    recruiterBody: 'The bulk upload processing exceeded the time limit. Some or all files may not have been processed. Please try uploading again.',
    candidateHeadline: 'Processing Took Too Long',
    candidateBody: 'The upload processing took too long. Please try again.',
  },

  unknown: {
    recruiterHeadline: 'Something Went Wrong',
    recruiterBody: 'An unexpected error occurred. Please try again.',
    candidateHeadline: 'Something Went Wrong',
    candidateBody: 'An unexpected error occurred. Please try again.',
  },
}
